import styled from "@emotion/styled";

export const TransitionBoxWrapper = styled.div`
  &.dropdown-enter {
    opacity: 0;
    ${({ p }) => p?.transformType && "transform: translateY(100%);"}
  }
  &.dropdown-enter-active {
    opacity: 1;
    transition:
      opacity 300ms,
      transform 300ms;
    ${({ p }) => p?.transformType && "transform: translateY(0);"}
  }
  &.dropdown-exit {
    opacity: 1;
    ${({ p }) => p?.transformType && "transform: translateY(0);"}
  }
  &.dropdown-exit-active {
    opacity: 0;
    transition:
      opacity 300ms,
      transform 300ms;
    ${({ p }) => p?.transformType && "transform: translateY(100%);"}
  }

  ${props => props.addStyles}
`;
